namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_domain_page, {

		flex: {
			grow: 0,
		},
		
		Settings : {
			width: '9rem',
			font: {
				size: '12px',
			},
			Body_content: {
				padding: 0,
			},

			'$mol_button': {
				padding: 0,
			},
		},
		
	} )
	
}
